'use client';

import { SnackbarProvider } from 'notistack';
import { type PropsWithChildren } from 'react';

import { TwoLineSnackbar } from '../components';

declare module 'notistack' {
    interface VariantOverrides {
        twoLine: true;
    }
}

export function SnackbarWrapperProvider({ children }: Readonly<PropsWithChildren>) {
    return (
        <SnackbarProvider
            Components={{
                twoLine: TwoLineSnackbar,
            }}
        >
            {children}
        </SnackbarProvider>
    );
}
